import { useMemo } from 'react'

const buildListSliceKey = (
  filters?: Record<string, unknown>,
  pagination?: Record<string, unknown>,
  sort?: Record<string, unknown>,
  serializer?: string,
) => JSON.stringify({ filters, pagination, sort, serializer })

export const useListSliceKey = (
  filters?: Record<string, unknown>,
  pagination?: Record<string, unknown>,
  sort?: Record<string, unknown>,
  serializer?: string,
) => {
  return useMemo(() => {
    return buildListSliceKey(filters, pagination, sort, serializer)
  }, [filters, pagination, sort, serializer])
}
